import { GroupProperties } from "./group.type";
import { GroupMemberProperties } from "./groupMember.type";
import { ETransferEmployeeStatus } from "./transferEmployee.type";
import { UserProperties } from "./user.type";

export enum ETransferMemberTeamStatus {
	WAITING = "WAITING",
	TRANSFERED = "TRANSFERED",
	CANCELED = "CANCELED",
}

export interface TransferMemberTeamProperties {
	transferMemberId: string;
	userId: string;
	originGroupId: string;
	originGroupMemberId: string;
	toGroupId: string;
	toGroupMemberId?: string;
	status: ETransferMemberTeamStatus | ETransferEmployeeStatus;
	metadata?: any;
	createdByUserId?: string;
	createdByUserMeta?: any;
	updatedAt: Date;
	createdAt: Date;

	user?: UserProperties;
	originGroup?: GroupProperties;
	originGroupMember?: GroupMemberProperties;
	toGroup?: GroupProperties;
	toGroupMember?: GroupMemberProperties;
}

export interface ListTransferMemberTeamQuery {
	filterUserId?: string;
	filterOriginGroupId?: string;
	filterOriginGroupMemberId?: string;
	filterToGroupId?: string;
	filterToGroupMemberId?: string;
	filterStatus?: string;
	includeData?: string;
	sort?: string;
}
